<script setup lang="ts">

import { RouterView } from 'vue-router';
import { onBeforeMount } from 'vue';

// utilizzo dei web worker attraverso il "BUSINESS DELEGATE PATTERN"
// ho messo una spiegazione fittizia dentro un README contenuto in src/services/README


// webWorker non è il WEB WORKER vero e proprio, ma solo una classe di servizio che incapsula
// il funzionamento di base attraverso il BUSINESS DELEGATE PATTERN

// import webWorker from "@/services/WebWorker";
// webWorker.request("test", {nome: 'Giacomo', cognome: 'MACCANTI'}).then(
// 	(data: any) => {
// 		//console.log('succes APP');
// 		//console.log(data);
// 	},
// 	(err: any) => {
// 		//console.log('errore APP');
// 	}
// )

onBeforeMount(() => {
	// attendiamo il montaggio dell'app Vue prima di nascondere il loader che è in index.html e comunque non prima di 1500ms per non dare il fastidio di vedere il loader per troppo poco tempo
	const mainLoader = document.getElementById('main-loader');
	setTimeout(function () {
		if (mainLoader) {
			mainLoader.style.display = 'none';
		}
	}, 1500);
});

</script>

<template>
	<RouterView />
</template>